module.exports = __webpack_public_path__ + "media/images/recruitment/landing/img_simulation-24747d30bc110886e0c6df5ec2536530.png";